import React from 'react';
import paymentTransferEngImage from '../../assets/payment_transfer/payment_transfer_ENG.jpg';

const PaymentTransferEng = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <img style={{ width: '100%', objectFit: 'contain' }} src={paymentTransferEngImage} alt='auto payout' />
    </div>
  )
}

export default PaymentTransferEng;